export enum Routes {
    MUSICS = "/media/musics",
    MUSIC = "/media/music",
    MUSIC_TEMPLATES = "/media/musicTemplates",
    MUSIC_TEMPLATE = "/media/musicTemplate",
    MUSIC_TRAININGS = "/musicTrainings",
    MUSIC_TRAINING = "/musicTraining",
    EXERCISES = "/exercises",
    EXERCISE = "/exercise",
    USER = "/user",
    USERS = "/users",
    MUSCLES = "/muscles",
    MUSCLE = "/muscle",
    USER_CHANGE_PASS = "/user/change/pass",
    EXPORTER = "/exporter",
    EXERCISE_TYPES = "/exerciseTypes",
    EXERCISE_TYPE = "/exerciseType",
    GYMS = "/gyms",
    GYM = "/gym",
    STUDENTS = "/students",
    STUDENT = "/student",
    CHALLENGES = "/challenges",
    CHALLENGE = "/challenge",
    GYM_REQUESTS = "/gym_requests"
}
